import { render, staticRenderFns } from "./UserHomeList.vue?vue&type=template&id=54a22b7c&scoped=true&"
import script from "./UserHomeList.vue?vue&type=script&lang=js&"
export * from "./UserHomeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a22b7c",
  null
  
)

export default component.exports